<template>
  <div class="flex flex-row items-center">
    <vue3-tags-input v-model:tags="tags"
                     v-model="tag"
                     :select="true"
                     :select-items="selectItems"
                     @on-select="handleSelectedTag"
                     @on-tags-changed="handleChangeTag"
                     :placeholder="placeholder"
    >
      <template #item="{ tag, index }">
        {{ tag.text }}
      </template>
      <template #no-data>
        No Data
      </template>
      <template #select-item="tag">
        {{ tag.text }}
      </template>
    </vue3-tags-input>
  </div>
</template>

<script>
import Vue3TagsInput from 'vue3-tags-input';
import Icon from "@/Shared/Icon.vue";

export default {
  components: {
    Icon,
    Vue3TagsInput
  },
  props: {
    editable: [Number, Boolean],
    editItem: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Add tags',
    },
    choices: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tags: this.modelValue.map(tag => ({text: tag.name, value: tag.id})),
      tag: '',
      selectItems: this.choices.map(choice => ({
        text: choice.name,
        value: choice.id
      })),
      editItem: this.editItem
    }
  },
  watch: {
    choices: {
      handler(newChoices) {
        this.selectItems = newChoices.map(choice => ({
          text: choice.name,
          value: choice.id
        }));
      },
      immediate: true
    },
    tags: {
      handler(newTags) {
        this.$emit('update:modelValue', newTags.map(tag => ({id: tag.value, name: tag.text})));
      },
      deep: true
    }
  },
  methods: {
    handleSelectedTag(tag) {
      if (this.tags.find(t => t.value === tag.value)) {
        return;
      }
      this.tags.push(tag);
    },
    handleChangeTag(tags) {
      this.tags = tags;
    },
  }
}
</script>
